import { Component, OnInit } from '@angular/core';

import { Attachment } from '../../objects/attachment';
// import { GlobalDataService } from '../global-data.service';
// import { ContractManagerService } from "../service/contract-manager.service";

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button'; 
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';


import { AutoCompleteModule } from 'primeng/autocomplete';



@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.css'],
    standalone: true,
    imports: [
      FormsModule,
      RouterModule,
      MatTabsModule,
      MatGridListModule,
      MatDividerModule,
      MatFormFieldModule,
      MatButtonModule,
      MatSidenavModule,
      MatButtonToggleModule,
      MatSlideToggleModule,
      MatSliderModule,
      MatDatepickerModule,
      MatIconModule,
      AutoCompleteModule
    ]
  })
export class AttachmentComponent implements OnInit {

  currentAttachment: Attachment;

  submitted = false;
  reviewer = true;

  constructor() { 
    this.currentAttachment = {};
  }

  async ngOnInit() {

  }

}
